import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {EnumerationService} from '../services/enumeration.service';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgDataListComponent} from 'exc-controls-v2';
import {ExgTabV2ComponentHeaderElement} from '../misc/exg-tab-v2/exg-tab-v2.component';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {AppComponent} from '../app.component';
import {ExcSecurityService} from 'exc-security-v2';
import {ApplicationService} from '../services/application.service';
import {ExgApplicationTab} from 'exc-tab-v2';
import {TaskListComponent} from '../task/task-list/task-list.component';
import {MessageListComponent} from '../message/message-list/message-list.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styles: [
  ]
})
export class HomeComponent extends ExcTranslation implements OnInit {
  @ViewChild('VCAblaufplanItemList', {read: ExgDataListComponent}) VCAblaufplanItemList!: ExgDataListComponent;

  /** Header Objects */
  init = true;
  userList: any;
  rightTabs: ExgTabV2ComponentHeaderElement[] = [];
  homeSummaryData = {
    case: {} as {
      cNew: number,
      cDisp: number,
      cReDisp: number,
      cActual: number,
      cFin: number,
      cComplained: number,
      cInvoicing: number,
      cDone: number,
      cStorno: number,
      cEsk: number,
      cSD2Vorgaenge: number,
      cOpenQuestion: number,
      cAll: number,
      cWIP: number,
      cFinal: number,
      cNotFinal: number,
      cOpen: number},
    task: {} as {
      cNew: number,
      cDisp: number,
      cReDisp: number,
      cActual: number,
      cReActual: number,
      cFin: number,
      cComplained: number,
      cInvoicing: number,
      cDone: number,
      Storno: number,
      cEsk: number,
      cSD2Vorgaenge: number,
      cOpenQuestion: number,
      cAll: number,
      cWIP: number,
      cFinal: number,
      cNotFinal: number,
      cOpen: number},
    message: {} as {
      cAll: number,
      cNew: number,
      cRead: number,
      cSent: number},
    aufgabe: {} as {
      cEscalated: number,
      cSendEscalated: number,
      cAll: number},
    ablaufplan: {
      isLoading: false,
      items: [] as any[],
      selectedRow: {} as any,
      selectedKey: 'apiID',
      state: 1,
      uiSortAktiv(): any[] {
        return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
      },
      uiFilterAktiv(filterType?: number): any[] {
        return this.uiFilter
          .filter((filters: any) => filters.applied)
          .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType));
      },
      uiFilterEnumGroup: [
        {
          enmName: 'Schadenart',
          enmField: 'aue_enmIdent_SchadenArt',
          enmTable: 'AuftragE_EIS',
          enmAlt: false,
          enmAltTT: true
        },
        {
          enmName: 'VorgangStatus',
          enmField: 'vorg_enmIdent_VorgangStatus',
          enmTable: 'Vorgang',
        },
        {
          enmName: 'VorgangTyp',
          enmField: 'vorg_enmIdent_VorgangTyp',
          enmTable: 'Vorgang',
        },
        {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
      ],
      uiFilterSearchFields: [
        {table: 'Vorgang', tableField: 'vorgNr'},
        {table: 'Vorgang', tableField: 'Bearbeiter'},
        {table: 'Vorgang', tableField: 'vorgFrist'},
        {table: 'AuftragE_EIS', tableField: 'aueSchadenOrt', groupCaption: 'Schaden'},
        {table: 'AuftragE_EIS', tableField: 'aueSchadenNr', groupCaption: 'Schaden'},
        {table: 'AuftragE_EIS', tableField: 'aueVersicherungsnehmer', groupCaption: 'Schaden'},
        {table: 'AuftragE_EIS', tableField: 'aueSchadenOrt', groupCaption: 'Schaden'},
        {table: 'Auftrag', tableField: 'auAuftraggeberShort', repColumn: 'au_oeID_Auftraggeber'},
        {table: 'Auftrag', tableField: 'auAnsprechpartner'},
      ],
      uiSortFieldGroup: [
        { fieldGroup: 'Ablaufplan', fieldTable: 'Ablaufplan', fieldName: 'DateDiffSoll_PlanDate', uiName: this.getRessource('DateDiffSoll_PlanDate') },
        { fieldGroup: 'Ablaufplan', fieldTable: 'Ablaufplan', fieldName: 'apiPlanDatum' },
        { fieldGroup: 'Ablaufplan', fieldTable: 'Ablaufplan', fieldName: 'apiSollDatum' },
        { fieldGroup: 'Ablaufplan', fieldTable: 'Ablaufplan', fieldName: 'apiIstDatum' },
        { fieldGroup: 'Ablaufplan', fieldTable: 'All', fieldName: 'apiCRD' },
        { fieldGroup: 'Ablaufplan', fieldTable: 'All', fieldName: 'apiLCD' },
      ],
      uiFilter: [] as any [],
      uiSort:  [] as any [],
      MetaInfo: {
        dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
        dataSort: {} as IExcDataSort,
        dataFilter: {} as IExcDataFilter
      } as IExcMetaInfo,
      paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
      searchValue: '',

      selectionChanged: (index: number) => {
        this.homeSummaryData.ablaufplan.selectedRow = this.homeSummaryData.ablaufplan.items[index];
      },
      ready: () => {
        if (this.homeSummaryData.ablaufplan.items.length === 0) {
          this.homeSummaryData.ablaufplan.state = 2;
          this.VCAblaufplanItemList.selectedRow = -1;
        } else {
          this.homeSummaryData.ablaufplan.state = 0;
          this.VCAblaufplanItemList.selectedRow = 0;
        }
      },
      isFiltered: () => {
        return (this.homeSummaryData.ablaufplan.uiFilter &&
          JSON.stringify({}) !== JSON.stringify(this.homeSummaryData.ablaufplan.MetaInfo.dataFilter));
      },
      pageChanged: (page: number) => {
        if (this.homeSummaryData.ablaufplan.MetaInfo.dataPaging !== undefined) {
          this.homeSummaryData.ablaufplan.MetaInfo.dataPaging.pageNo = page;
        }
        this.homeSummaryData.ablaufplan.loadHomeAblaufplan();
      },
      search: (value: string) => {
        this.homeSummaryData.ablaufplan.searchValue = value;
        this.homeSummaryData.ablaufplan.pageChanged(1);
      },
      loadData: (incomingAPIs?: any, incomingAPIPaging?: any) => {
        this.homeSummaryData.ablaufplan.items = incomingAPIs;
        this.homeSummaryData.ablaufplan.paging = incomingAPIPaging;
      },
      loadHomeAblaufplan: (): void => {
        const SELF = this;
        SELF.homeSummaryData.ablaufplan.isLoading = true;
        SELF.homeSummaryData.ablaufplan.state = 1;
        SELF.excRestService
          .get(SELF.excRestService.computeUrl('HomeR_Ablaufplan',
            { fts: this.homeSummaryData.ablaufplan.searchValue }
          ), { MetaInfo: this.homeSummaryData.ablaufplan.MetaInfo })
          .subscribe(
            (data: any) => {
              if (data && data.success) {
                SELF.homeSummaryData.ablaufplan.loadData(
                  data.data.AblaufPlanItem,
                  data.paging.AblaufPlanItem);
              }
              SELF.homeSummaryData.ablaufplan.isLoading = false;
              if (data.data.AblaufPlanItem.length > 0) {
                SELF.homeSummaryData.ablaufplan.state = 0;
              } else {
                SELF.homeSummaryData.ablaufplan.state = 2;
              }
            }
          );
      }
    },
    absence: {
      data: [] as any[],
      state: 1,
      selectedRow: {} as any,
    },
    loadData: (incomingCase: any, incomingTask?: any,
               incomingMassages?: any, incomingAufgaben?: any,
               incomingAPIs?: any, incomingAPIPaging?: any,
               incomingAbsences?: any) => {
      this.homeSummaryData.case = incomingCase;
      this.homeSummaryData.task = incomingTask;
      this.homeSummaryData.message = incomingMassages;
      this.homeSummaryData.aufgabe = incomingAufgaben;
      this.homeSummaryData.ablaufplan.loadData(incomingAPIs, incomingAPIPaging);
      this.homeSummaryData.absence.data = incomingAbsences;
    }
  };
  perparedSummaryData = {
    taskFilter: ['cFinal', 'cNotFinal', 'cAll', 'cDone'],
    caseFilter: ['cFinal', 'cNotFinal', 'cAll', 'cDone'],
    task: [] as any[],
    taskTyp: [] as any[],
    case: [] as any[],
    caseTyp: [] as any[],
    message: [] as any[],
    aufgabe: [] as any[],
    loadEnumerationTypes: (values: any[], enumerationName: 'AuftragTyp' | 'VorgangTyp'): void => {
      if (enumerationName === 'AuftragTyp') {
        for (const value of values) {
          this.perparedSummaryData.caseTyp.push(
            {name: this.enumSvc.getEnumerationText(enumerationName, value.au_enmIdent_AuftragTyp), value: value.Value}
          );
        }
      } else if (enumerationName === 'VorgangTyp') {
        for (const value of values) {
          this.perparedSummaryData.taskTyp.push(
            {name: this.enumSvc.getEnumerationText(enumerationName, value.vorg_enmIdent_VorgangTyp), value: value.Value}
          );
        }
      }
    },
    resetValues(): void {
      this.task = [];
      this.taskTyp = [];
      this.case = [];
      this.caseTyp = [];
      this.message = [];
      this.aufgabe = [];
    }
  };
  _isLoading = true;
  get isLoading(): boolean {
    return this._isLoading;
  }
  set isLoading(value: boolean) {
    this._isLoading = value;
    if (this.isLoading) {
      this.homeSummaryData.ablaufplan.state = 1;
      this.homeSummaryData.absence.state = 1;
    } else {
      if (this.homeSummaryData.absence.data.length === 0) {
        this.homeSummaryData.absence.state = 2;
      } else {
        this.homeSummaryData.absence.state = 0;
        this.homeSummaryData.absence.selectedRow = undefined;
      }
      if (this.homeSummaryData.ablaufplan.items.length === 0) {
        this.homeSummaryData.ablaufplan.state = 2;
      } else {
        this.homeSummaryData.ablaufplan.state = 0;
        this.homeSummaryData.ablaufplan.selectedRow = undefined;
      }
    }
  }


  constructor(
    private appSvc: ApplicationService,
    private chDecRef: ChangeDetectorRef,
    private excRestService: ExcRestService,
    public excSecurity: ExcSecurityService,
    public enumSvc: EnumerationService,
    public app: AppComponent) {
    super();
  }


  ngOnInit(): void {
    this.registerEvents();
    if (!this.enumSvc.loading) {
      this.initialize();
    }
  }

  initialize(): void {
    const SELF = this;
    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getGlobal('Details');
        },
        icon_class: SELF.getRessource('DetailsIcon')
      },
      {
        get caption(): string {
          return SELF.getRessource('refReceipts');
        },
        icon_class: SELF.getRessource('RefIcon')
      }
    ];
    SELF.loadHomeSummary();
  }

  initEnumerations(): void {
    this.homeSummaryData.ablaufplan.uiFilter = this.appSvc.metaInfo.dataFilter(
      this.homeSummaryData.ablaufplan.uiFilterEnumGroup,
      this.homeSummaryData.ablaufplan.uiFilterSearchFields);
    this.homeSummaryData.ablaufplan.uiSort = this.appSvc.metaInfo.dataSort(this.homeSummaryData.ablaufplan.uiSortFieldGroup);
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      this.loadHomeSummary();
    });
    this.enumSvc.repositoryLoaded.subscribe(() => {
      this.initEnumerations();
      this.initialize();
    });
  }

  loadHomeSummary(): void {
    const SELF = this;
    SELF.isLoading = true;
    this.perparedSummaryData.resetValues();
    SELF.excRestService
      .get(SELF.excRestService.computeUrl('HomeR_Summary',
          { fts: this.homeSummaryData.ablaufplan.searchValue }
      ), { MetaInfo: this.homeSummaryData.ablaufplan.MetaInfo })
      .subscribe(
        (data: any) => {
          if (data && data.success) {
            SELF.homeSummaryData.loadData(
              data.data.Auftrag,
              data.data.Vorgang,
              data.data.Nachricht,
              data.data.Aufgaben,
              data.data.AblaufPlanItem,
              data.paging.AblaufPlanItem,
              data.data.Absence);
            SELF.prepareSummaryData(data.data.Auftrag, 'case', 'caseFilter');
            SELF.prepareSummaryData(data.data.Vorgang, 'task', 'taskFilter');
            SELF.prepareSummaryData(data.data.Nachricht, 'message', undefined);
            SELF.prepareSummaryData(data.data.Aufgaben, 'aufgabe', undefined);
            SELF.perparedSummaryData.loadEnumerationTypes(data.data.AuftragTyp, 'AuftragTyp');
            SELF.perparedSummaryData.loadEnumerationTypes(data.data.VorgangTyp, 'VorgangTyp');
            try {
              SELF.app.userData.OEFullname = data.data.UserOE.oeFullname;
            }
            catch (ex){}
          }
          if (SELF.init) {
            SELF.init = false;
          }
          SELF.isLoading = false;
        }
      );
  }

  prepareSummaryData(input: any, caption: 'task' | 'case' | 'message' | 'aufgabe', filter: 'taskFilter' | 'caseFilter' | undefined): void {
    for (const key of Object.keys(input)) {
      if (filter && this.perparedSummaryData[filter].includes(key)) {
        return;
      }
      this.perparedSummaryData[caption].push({name: this.getRessource(`${caption}.${key}`), value: input[key]});
    }
  }

  calculatePercentage(num: number, total: number): string {
    return total && total > 0 ? (num * 100 / total).toFixed(2) : (0).toFixed(2);
  }

  openTab(event: any, navItemTyp: number, dataValue: number, addValue ?: any): void {
    let navItemCaption = '';
    let navItemIcon = '';
    let navItemComponent: any;

    event.preventDefault();
    event.stopPropagation();

    if (navItemTyp === 1) {
      navItemCaption = 'Vorgangsliste';
      navItemIcon = 'fa-regular fa-clipboard-list';
      navItemComponent = TaskListComponent;
      if (addValue === true) {
        addValue = {
          applyFilters: true,
          vorgangstatusFilter: [13, 5]
        };
      }
    } else if (navItemTyp === 2) {
      navItemCaption = 'Nachrichtenliste';
      navItemIcon = 'fa-regular fa-mail-bulk';
      navItemComponent = MessageListComponent;
    } else if (navItemTyp === 3) {

    }
    new ExgApplicationTab(
      navItemCaption,
      navItemComponent,
      {inputPreFilterValue: dataValue, addValue},
      '00000000-0000-0000-0000-000000000000',
      {Unique: false},
      true,
      navItemIcon
    ).Open(event);
  }
}
